import { dispatch } from 'redux-store/dispatch';

import { RECEIVE_ROLES } from './constants';

import type { Role } from 'types';

export const receiveRoles = (roles: Array<Role>) => dispatch({
  type: RECEIVE_ROLES,
  payload: {
    roles
  }
});
